'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import { useAppDispatch } from '@/hooks/redux';
import { hideToolSide } from '@/store/slices/toolSideSlice';
import { resetAll } from '@/features/tool/slices/toolSlice';
import {
  setFreeTypeForUserAccessLevel,
  setTypeForUserAccessLevel,
} from '@/store/slices/userAccessSlice';
import usePrevious from '@/hooks/usePrevious';
import { hideModal } from '@/store/slices/modalSlice';

const RouteChangeListener = () => {
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  const previousPathname = usePrevious(pathname);

  React.useEffect(() => {
    const isLoginRedirection =
      previousPathname &&
      previousPathname === '/' &&
      pathname.startsWith('/app');

    if (!isLoginRedirection) {
      dispatch(setFreeTypeForUserAccessLevel(null));
      dispatch(setTypeForUserAccessLevel(null));
      dispatch(hideModal());
    }

    if (!pathname.startsWith('/app')) {
      dispatch(hideToolSide());
      dispatch(resetAll());
    }
  }, [pathname, previousPathname]);

  return null;
};

export default RouteChangeListener;
